import script from "./PulsatingDot.vue?vue&type=script&setup=true&lang=ts"
export * from "./PulsatingDot.vue?vue&type=script&setup=true&lang=ts"

import "./PulsatingDot.vue?vue&type=style&index=0&id=508cc8c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508cc8c4"]])

export default __exports__